import API from './api';

// Fetch all page visibility settings
export const getAllPageVisibility = async () => {
  try {
    console.log('Calling API to get all page visibility settings');
    const response = await API.get('/page-visibility');
    console.log('API response for getAllPageVisibility:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching page visibility settings:', error);
    // Add more detailed error information
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('Request made but no response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};

// Create a new page visibility setting
export const createPageVisibility = async (pageData) => {
  try {
    // Ensure isVisible is explicitly a boolean
    if (pageData.isVisible !== undefined) {
      pageData.isVisible = Boolean(pageData.isVisible);
    }
    
    // Ensure maintenanceMode is explicitly a boolean
    if (pageData.maintenanceMode !== undefined) {
      pageData.maintenanceMode = Boolean(pageData.maintenanceMode);
    }
    
    console.log('Creating page visibility with data:', pageData);
    const response = await API.post('/page-visibility', pageData);
    return response.data;
  } catch (error) {
    console.error('Error creating page visibility setting:', error);
    throw error;
  }
};

// Update a page visibility setting
export const updatePageVisibility = async (id, pageData) => {
  try {
    console.log(`Updating page visibility for ID: ${id}`, pageData);
    
    // Ensure isVisible is explicitly a boolean
    if (pageData.isVisible !== undefined) {
      pageData.isVisible = Boolean(pageData.isVisible);
    }
    
    // Ensure maintenanceMode is explicitly a boolean
    if (pageData.maintenanceMode !== undefined) {
      pageData.maintenanceMode = Boolean(pageData.maintenanceMode);
    }
    
    const response = await API.put(`/page-visibility/${id}`, pageData);
    console.log('Update response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating page visibility setting:', error);
    // Add more detailed error information
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('Request made but no response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};

// Delete a page visibility setting
export const deletePageVisibility = async (id) => {
  try {
    // Use the enhanced delete method with retry capability
    console.log(`Deleting page visibility with ID: ${id}`);
    const response = await API.delete(`/page-visibility/${id}`);
    console.log('Delete response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting page visibility setting:', error);
    // Add more detailed error information
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Request made but no response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};

// Check if a page is visible and get maintenance status
export const checkPageVisibility = async (path) => {
  try {
    const response = await API.get(`/page-visibility/check/${encodeURIComponent(path)}`);
    return response.data;
  } catch (error) {
    console.error('Error checking page visibility:', error);
    // Default to visible and not in maintenance if there's an error
    return {
      isVisible: true,
      maintenanceMode: false,
      maintenanceMessage: null
    };
  }
};

// Check visibility and maintenance status for multiple pages at once
export const bulkCheckPageVisibility = async (paths) => {
  try {
    const response = await API.post('/page-visibility/bulk-check', { paths }, {
      timeout: 10000,
      retry: 0,
      skipErrorInterceptorLog: true
    });
    return response.data;
  } catch (error) {
    const isTransient = (
      error?.code === 'ERR_NETWORK'
      || error?.code === 'ECONNABORTED'
      || [502, 503, 504].includes(error?.response?.status)
    );

    if (!isTransient) {
      console.error('Error checking bulk page visibility:', error);
    }
    // Default all to visible and not in maintenance if there's an error
    const result = {};
    paths.forEach(path => {
      result[path] = {
        isVisible: true,
        maintenanceMode: false,
        maintenanceMessage: null
      };
    });
    return result;
  }
};